import { OptionalAssets } from '@monorepo/types';
import {
  QUERY_CONFIGS,
  QueryConfigKeys,
} from '@hub/utils/react-query/query-config';
import {
  fetchAddOns,
  fetchProductsAsset,
  fetchProgramsAndGroups,
} from '@hub/utils/react-query/query-functions';
import { QUERY_KEYS } from '@hub/utils/react-query/query-keys';
import { ExtractFnReturnType } from '@hub/utils/react-query/react-query';
import { skipToken, useQuery } from '@tanstack/react-query';

const CONFIG_KEY = QueryConfigKeys.PRODUCTS;

export const useProducts = () => {
  return useQuery<ExtractFnReturnType<typeof fetchProgramsAndGroups>>({
    queryKey: QUERY_KEYS[CONFIG_KEY].PROGRAMS_AND_GROUPS(),
    queryFn: () => fetchProgramsAndGroups(),
    staleTime: QUERY_CONFIGS[CONFIG_KEY].staleTime,
    enabled: false,
    refetchOnMount: false,
  });
};

export const useGetAddOns = ({
  accountId,
  enabled,
}: {
  accountId: string;
  enabled: boolean;
}) => {
  return useQuery<ExtractFnReturnType<typeof fetchAddOns>>({
    queryKey: QUERY_KEYS[QueryConfigKeys.ADD_ONS].LIST(accountId),
    queryFn: () => fetchAddOns(accountId),
    enabled,
  });
};

export const useProductsAsset = (asset?: OptionalAssets) => {
  return useQuery<ExtractFnReturnType<typeof fetchProductsAsset>>({
    queryKey: QUERY_KEYS[CONFIG_KEY].ASSET(asset),
    queryFn: asset ? () => fetchProductsAsset(asset) : skipToken,
    staleTime: QUERY_CONFIGS[CONFIG_KEY].staleTime,
    enabled: Boolean(asset),
  });
};
